import { render, staticRenderFns } from "./MoleculeCardImageButton.vue?vue&type=template&id=3ae8c690"
import script from "./MoleculeCardImageButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeCardImageButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports